import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getOrderAPI } from "../../service/cart.service";
import OrderStatusTemplate from "./order-status.template";
import { useParams } from "react-router-dom";

const OrderStatusComponent = () => {
  const [order, setOrder] = useState(null);
  const navigate = useNavigate();
  const { orderId } = useParams();
  console.log({orderId});
  

  const onLoad = async () => {
    const resp = await getOrderAPI(orderId);

    console.log({ resp });
    if (resp.status) setOrder(resp.data);
  };

  const handleOrderDetailClick = () => {
    navigate("/account", { state: { openTab: "orders" } });
  };

  useEffect(() => {
    if (orderId) {
      onLoad();
    }
  }, [orderId]);

  const templateModal = {
    order,
  };

  const templateEvents = {
    handleOrderDetailClick,
  };

  return (
    <OrderStatusTemplate
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  );
};

export default OrderStatusComponent;
